import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './BreadCrumbNav.css'

class BreadCrumbNav extends Component {
  constructor(props) {
    super(props);
    const { screenName, prevLinks } = this.props;
    this.state = {
      screenName,
      prevLinks
    };
  }

  render() {
    return (
      <div className='breadcrumb-container'>
        <Link className='breadcrumb-master__item breadcrumb-master__item-color' to='/index.html'>
          端末管理システム
        </Link>
        {this.state.prevLinks && this.state.prevLinks.map((item, index) => (
          <div key={index} className='breadcrumb-master__item'>
            <div className='breadcrumb-master__item' >{` ＞ `}</div>
            <Link className='breadcrumb-master__item breadcrumb-master__item-color' to={item.url}>
              {`${item.text}`}
            </Link>
          </div>
        ))}
        <div className='breadcrumb-master__item' >{` ＞ ${this.state.screenName}`}</div>
        <br />
      </div>
    )
  }
}

export default BreadCrumbNav
